
define('ldsh!modules/form_editor/templates/preview_custom_gender', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if(labelVisible) { ;
__p += '\n<label class="control-label col-sm-3" for="' +
((__t = ( elementId )) == null ? '' : __t) +
'">' +
((__t = ( labelText )) == null ? '' : __t) +
'</label>\n';
 } ;
__p += '\n<div class="col-sm-9 js-control">\n<select\n  name="' +
((__t = ( nameAttr )) == null ? '' : __t) +
'"\n  class="gender-select form-control js-items ' +
((__t = ( isRequired ? 'form-element-required' : '' )) == null ? '' : __t) +
'"\n  id="' +
((__t = ( elementId )) == null ? '' : __t) +
'"></select>\n</div>\n';

}
return __p
};});

